import { render } from "./Privileges.vue?vue&type=template&id=34d26b89&scoped=true&ts=true"
import script from "./Privileges.vue?vue&type=script&lang=ts"
export * from "./Privileges.vue?vue&type=script&lang=ts"

import "./Privileges.vue?vue&type=style&index=0&id=34d26b89&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d26b89"]])

export default __exports__